module.exports = __webpack_public_path__ + "static/media/left-arrow-orange.a633d8a9.svg";